import { DRIVE_SYNC_INTERNAL } from "../features";

export function syncReviewId() {
  if (
    !DRIVE_SYNC_INTERNAL ||
    typeof location === "undefined" ||
    !["/sync-review", "/sync-pair"].includes(location.pathname)
  )
    return undefined;
  const approved = ["localhost", "127.0.0.1", "classroom-desk-sync-review.pages.dev"];
  if (!approved.includes(location.hostname)) return undefined;
  const id = new URLSearchParams(location.search).get("device") || "test";
  if (!/^[a-zA-Z0-9_-]{1,32}$/.test(id)) throw new Error("sync-review-id");
  return id;
}
